export default __webpack_public_path__ + "static/media/Group 485@2x.3334f104.png";